import { useNavigate, useSearchParams } from "react-router-dom";
import React, { useContext, useEffect } from "react";
import { AuthContext } from "../../utils/AuthContext";
import "./Login.css";

const messages = {
  logout: "You have been successfully logged out.",
};

const errorMessages = {
  general: "Login failed. Please try again.",
  oracle:
    "We're trouble communicating with the sign-in service. Please try again later.",
  authenticate:
    "We're having trouble authenticating you. Please try again later.",
  server: "Server error during login. Please try again later.",
  access: "Access denied. Please contact your manager.",
};

const Login = () => {
  const { token } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const errorType = searchParams.get("error");
  const message = searchParams.get("message");
  const pageMessage = message ? messages[message] : null;
  const errorMessage = errorType ? errorMessages[errorType] : null;

  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate("/");
    }
  }, [navigate, token]);

  return (
    <section className="login-container">
      {pageMessage && <p className="login-message">{pageMessage}</p>}
      {errorMessage && <p className="login-error">{errorMessage}</p>}
      <header className="login-header">
        <h3 className="login-heading">Please Login to Continue</h3>
      </header>
      <a
        href={`${process.env.REACT_APP_AUTH_URL}/login?app=bus_assignments`}
        className="login-link"
      >
        Login
      </a>
    </section>
  );
};
export default Login;
